


















import { Component, Prop, Vue, Watch, Mixins, Emit } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import Swiper from 'swiper';

@Component
export default class AdvantagesAndMaterialsSlider extends Vue {

  @Prop({ default: false }) active!: boolean;
  swiper: Swiper | null = null;

  $refs!: {
    container: HTMLElement;
    slider:HTMLElement;
  }

  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;


  next() {
    this.swiper!.slideNext();
  }


  prev() {
    this.swiper!.slidePrev();
  }


  @Watch("active")
  activityChange(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.firstEnterAnimation();
    } else {
      this.leaveToAnotherScreen();
    }
  }


  @Emit("slideChange")
  slideChange(number: number) { }


  selectItem(number: number) {
    this.swiper!.slideTo(number);
  }


  changeSlideNumber(currentSlideNumber: number) {
    this.slideChange(currentSlideNumber);
  }


  mounted() {
    this.swiper = new Swiper(this.$refs.container, {
      loop: true,
      speed: 1100,
      autoHeight: !this.scrollingByScreens,
      pagination: {
        el: '.advantages-and-materials-slider .swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });

    this.swiper!.on('slideChangeTransitionStart', () => {
      this.changeSlideNumber(this.swiper!.realIndex + 1);
      this.slideChangeAnimation();
    });

    setTimeout(() => {
      let activeSlideWrap = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active .slide-wrap");
      activeSlideWrap!.style.opacity = "0";
    }, 100);
  }


  slideChangeAnimation() {
    let activeSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active");
    let number = activeSlide!.querySelector<HTMLElement>(".slide-info__background-number");
    anime.remove(number);
    anime({
      targets: number,
      duration: 750,
      easing: "easeOutQuad",
      opacity: [0, 0.2],
      delay: 100,
      translateY: [number!.offsetHeight, 0]
    });

    let prevSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-prev");
    let prevSlideNumber = prevSlide!.querySelector<HTMLElement>(".slide-info__background-number");
    anime.remove(prevSlideNumber);
    anime({
      targets: prevSlideNumber,
      duration: 750,
      easing: "easeOutQuad",
      opacity: [0.2, 0],
      translateY: [0, number!.offsetHeight * 0.5]
    });
  }


  firstEnterAnimation() {
    let activeSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active");
    let slideWrap = activeSlide!.querySelector<HTMLElement>(".slide-wrap");
    let title = activeSlide!.querySelector<HTMLElement>(".slide-info__title");
    let text = activeSlide!.querySelector<HTMLElement>(".slide-info__text");
    let number = activeSlide!.querySelector<HTMLElement>(".slide-info__background-number");
    let lines = activeSlide!.querySelector<HTMLElement>(".lines");
    let imageTagWrap = activeSlide!.querySelector<HTMLElement>(".slide-info__img");
    let buttons = this.$refs.slider.querySelectorAll<HTMLElement>(".control-buttons > *");

    imageTagWrap!.style.opacity = "0";

    setTimeout(() => {
      lines!.classList.add("active");
      anime({
        targets: imageTagWrap,
        delay: 1400,
        duration: 900,
        easing: "easeOutQuad",
        opacity: 1
      });
    }, 50);

    anime({
      targets: title,
      duration: 1000,
      easing: "easeOutQuad",
      delay: 200,
      opacity: [0, 1],
      translateX: [text!.offsetWidth / 2, 0]
    });

    anime({
      targets: text,
      duration: 1000,
      delay: 200,
      easing: "easeOutQuad",
      opacity: [0, 1],
      translateX: [text!.offsetWidth / 2, 0]
    });

    anime({
      targets: number,
      duration: 1000,
      easing: "easeOutQuad",
      opacity: [0, 0.2],
      translateY: [number!.offsetHeight / 1.5, 0]
    });

    anime({
      targets: buttons,
      duration: 400,
      easing: "easeOutQuad",
      opacity: [0, 1]
    })

    slideWrap!.style.opacity = "1";
  }


  leaveToAnotherScreen() {
    let activeSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active");
    let slideWrap = activeSlide!.querySelector<HTMLElement>(".slide-wrap");
    let title = activeSlide!.querySelector<HTMLElement>(".slide-info__title");
    let text = activeSlide!.querySelector<HTMLElement>(".slide-info__text");
    let number = activeSlide!.querySelector<HTMLElement>(".slide-info__background-number");
    let lines = activeSlide!.querySelector<HTMLElement>(".lines");
    let imageTagWrap = activeSlide!.querySelector<HTMLElement>(".slide-info__img");
    let buttons = this.$refs.slider.querySelectorAll<HTMLElement>(".control-buttons > *");

    anime.remove(imageTagWrap);
    anime({
      targets: imageTagWrap,
      duration: 500,
      easing: "easeOutQuad",
      opacity: 0
    });

    setTimeout(() => {
      lines!.classList.remove("active");
    }, 100)

    anime({
      targets: title,
      duration: 1000,
      easing: "easeOutQuad",
      opacity: [1, 0],
      translateX: [0, text!.offsetWidth / 2]
    });

    anime({
      targets: text,
      duration: 1000,
      easing: "easeOutQuad",
      opacity: [1, 0],
      translateX: [0, text!.offsetWidth / 2]
    });

    anime({
      targets: number,
      duration: 1000,
      easing: "easeOutQuad",
      opacity: [0.2, 0],
      translateY: [0, number!.offsetHeight / 1.5]
    })

    anime({
      targets: buttons,
      duration: 400,
      easing: "easeOutQuad",
      opacity: [1, 0]
    })
  }
}
